<div class="row">
  @if (result.life) {
    <p class="col-4 col-lg-3 mb-1 text-end">
      <strong>Life</strong><br />
      {{ result.life }} years
    </p>
  }

  @for (rateName of rates; track rateName) {
    <p class="col mb-1 text-end">
      @if (getLife(rateName, result); as life) {
        <strong>
          <abbr [title]="rateName">{{ getRateAbbr(rateName, result) }}</abbr>
          Life
        </strong>
        <br />
        {{ life }} years
      }
      @if (getRate(rateName, result); as rate) {
        <strong>
          <abbr [title]="rateName">{{ getRateAbbr(rateName, result) }}</abbr>
          Rate
        </strong>
        <br />
        {{ rate | aapercent }}
      }
    </p>
  }

  <div class="col-lg-4">
    <button
      data-dd-action-name="depreciation-lookup-search-item-select.select-button"
      type="button"
      class="btn btn-outline w-100"
      (click)="selectAlternate.emit()"
    >
      Select
    </button>
  </div>
</div>

<p class="text-end text-sm my-1">
  Ref:
  @if (result.href) {
    <a
      data-dd-action-name="depreciation-lookup-search-item-select.ruling-link"
      [href]="result.href"
      target="_blank"
      rel="noopener noreferrer"
    >
      {{ result.ruling }}
      <i-lucide name="external-link"></i-lucide>
    </a>
  }
  @if (!result.href) {
    {{ result.ruling }}
  }
</p>
